import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=20c0feff&scoped=true&"
import script from "./FaqView.vue?vue&type=script&lang=js&"
export * from "./FaqView.vue?vue&type=script&lang=js&"
import style0 from "./FaqView.vue?vue&type=style&index=0&id=20c0feff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0feff",
  null
  
)

export default component.exports